export const BASE_BACKEND_LOCAL_URL = "http://127.0.0.1:8000";
export const BASE_BACKEND_STAGE_URL = "https://monolith-backend-stage.doorwash.com"
export const BASE_BACKEND_PROD_URL = "https://monolith-backend.doorwash.com"
export const API_PATH = "/api/v1/"